"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.filter");

require("core-js/modules/es.array.find");

require("core-js/modules/es.array.from");

require("core-js/modules/es.array.index-of");

require("core-js/modules/es.array.is-array");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.array.map");

require("core-js/modules/es.array.slice");

require("core-js/modules/es.date.to-string");

require("core-js/modules/es.function.name");

require("core-js/modules/es.object.define-property");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.promise");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/es.string.replace");

require("core-js/modules/web.dom-collections.iterator");

require("core-js/modules/web.timers");

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Utils = void 0;

var Enums_1 = require("../Enums");

var ColorUtils_1 = require("./ColorUtils");

var Utils = /*#__PURE__*/function () {
  function Utils() {
    _classCallCheck(this, Utils);
  }

  _createClass(Utils, null, [{
    key: "isSsr",
    value: function isSsr() {
      return typeof window === "undefined" || !window;
    }
  }, {
    key: "replaceColorSvg",
    value: function replaceColorSvg(image, color, opacity) {
      if (!image.svgData) {
        return "";
      }

      var svgXml = image.svgData;
      var rgbHex = /#([0-9A-F]{3,6})/gi;
      return svgXml.replace(rgbHex, function () {
        return ColorUtils_1.ColorUtils.getStyleFromHsl(color, opacity);
      });
    }
  }, {
    key: "clamp",
    value: function clamp(num, min, max) {
      return Math.min(Math.max(num, min), max);
    }
  }, {
    key: "isInArray",
    value: function isInArray(value, array) {
      return value === array || array instanceof Array && array.indexOf(value) > -1;
    }
  }, {
    key: "mix",
    value: function mix(comp1, comp2, weight1, weight2) {
      return Math.floor((comp1 * weight1 + comp2 * weight2) / (weight1 + weight2));
    }
  }, {
    key: "getParticleBaseVelocity",
    value: function getParticleBaseVelocity(particle) {
      var velocityBase;

      switch (particle.direction) {
        case Enums_1.MoveDirection.top:
          velocityBase = {
            x: 0,
            y: -1
          };
          break;

        case Enums_1.MoveDirection.topRight:
          velocityBase = {
            x: 0.5,
            y: -0.5
          };
          break;

        case Enums_1.MoveDirection.right:
          velocityBase = {
            x: 1,
            y: -0
          };
          break;

        case Enums_1.MoveDirection.bottomRight:
          velocityBase = {
            x: 0.5,
            y: 0.5
          };
          break;

        case Enums_1.MoveDirection.bottom:
          velocityBase = {
            x: 0,
            y: 1
          };
          break;

        case Enums_1.MoveDirection.bottomLeft:
          velocityBase = {
            x: -0.5,
            y: 1
          };
          break;

        case Enums_1.MoveDirection.left:
          velocityBase = {
            x: -1,
            y: 0
          };
          break;

        case Enums_1.MoveDirection.topLeft:
          velocityBase = {
            x: -0.5,
            y: -0.5
          };
          break;

        default:
          velocityBase = {
            x: 0,
            y: 0
          };
          break;
      }

      return velocityBase;
    }
  }, {
    key: "getDistances",
    value: function getDistances(pointA, pointB) {
      var dx = pointA.x - pointB.x;
      var dy = pointA.y - pointB.y;
      return {
        dx: dx,
        dy: dy,
        distance: Math.sqrt(dx * dx + dy * dy)
      };
    }
  }, {
    key: "getDistance",
    value: function getDistance(pointA, pointB) {
      return this.getDistances(pointA, pointB).distance;
    }
  }, {
    key: "loadFont",
    value: function loadFont(character) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return document.fonts.load("".concat(character.weight, " 36px '").concat(character.font, "'"));

              case 3:
                _context.next = 7;
                break;

              case 5:
                _context.prev = 5;
                _context.t0 = _context["catch"](0);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 5]]);
      }));
    }
  }, {
    key: "arrayRandomIndex",
    value: function arrayRandomIndex(array) {
      return Math.floor(Math.random() * array.length);
    }
  }, {
    key: "itemFromArray",
    value: function itemFromArray(array, index) {
      return array[index !== undefined ? index : this.arrayRandomIndex(array)];
    }
  }, {
    key: "randomInRange",
    value: function randomInRange(r1, r2) {
      var max = Math.max(r1, r2);
      var min = Math.min(r1, r2);
      return Math.random() * (max - min) + min;
    }
  }, {
    key: "isPointInside",
    value: function isPointInside(point, size, radius) {
      return this.areBoundsInside(this.calculateBounds(point, radius !== null && radius !== void 0 ? radius : 0), size);
    }
  }, {
    key: "areBoundsInside",
    value: function areBoundsInside(bounds, size) {
      return bounds.left < size.width && bounds.right > 0 && bounds.top < size.height && bounds.bottom > 0;
    }
  }, {
    key: "calculateBounds",
    value: function calculateBounds(point, radius) {
      return {
        bottom: point.y + radius,
        left: point.x - radius,
        right: point.x + radius,
        top: point.y - radius
      };
    }
  }, {
    key: "loadImage",
    value: function loadImage(source) {
      return new Promise(function (resolve, reject) {
        var image = {
          source: source,
          type: source.substr(source.length - 3)
        };

        if (source) {
          var img = new Image();
          img.addEventListener("load", function () {
            image.element = img;
            resolve(image);
          });
          img.addEventListener("error", function () {
            reject("Error tsParticles - loading image: ".concat(source));
          });
          img.src = source;
        } else {
          reject("Error tsParticles - No image.src");
        }
      });
    }
  }, {
    key: "downloadSvgImage",
    value: function downloadSvgImage(source) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var image, response;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!source) {
                  _context2.next = 17;
                  break;
                }

                image = {
                  source: source,
                  type: source.substr(source.length - 3)
                };

                if (!(image.type !== "svg")) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt("return", this.loadImage(source));

              case 4:
                _context2.next = 6;
                return fetch(image.source);

              case 6:
                response = _context2.sent;

                if (!response.ok) {
                  _context2.next = 14;
                  break;
                }

                _context2.next = 10;
                return response.text();

              case 10:
                image.svgData = _context2.sent;
                return _context2.abrupt("return", image);

              case 14:
                throw new Error("Error tsParticles - Image not found");

              case 15:
                _context2.next = 18;
                break;

              case 17:
                throw new Error("Error tsParticles - No image.src");

              case 18:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "deepExtend",
    value: function deepExtend(destination) {
      var _this = this;

      for (var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        sources[_key - 1] = arguments[_key];
      }

      for (var _i = 0, _sources = sources; _i < _sources.length; _i++) {
        var source = _sources[_i];

        if (source === undefined || source === null) {
          continue;
        }

        if (typeof source !== "object") {
          destination = source;
          continue;
        }

        var sourceIsArray = Array.isArray(source);

        if (sourceIsArray && (typeof destination !== "object" || !destination || !Array.isArray(destination))) {
          destination = [];
        } else if (!sourceIsArray && (typeof destination !== "object" || !destination || Array.isArray(destination))) {
          destination = {};
        }

        var _loop = function _loop(key) {
          if (key === "__proto__") {
            return "continue";
          }

          var value = source[key];
          var isObject = typeof value === "object";
          destination[key] = isObject && Array.isArray(value) ? value.map(function (v) {
            return _this.deepExtend(destination[key], v);
          }) : _this.deepExtend(destination[key], value);
        };

        for (var key in source) {
          var _ret = _loop(key);

          if (_ret === "continue") continue;
        }
      }

      return destination;
    }
  }, {
    key: "isDivModeEnabled",
    value: function isDivModeEnabled(mode, divs) {
      return divs instanceof Array ? divs.filter(function (t) {
        return t.enable && Utils.isInArray(mode, t.mode);
      }).length > 0 : Utils.isInArray(mode, divs.mode);
    }
  }, {
    key: "divModeExecute",
    value: function divModeExecute(mode, divs, callback) {
      if (divs instanceof Array) {
        var _iterator = _createForOfIteratorHelper(divs),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var div = _step.value;
            var divMode = div.mode;
            var divEnabled = div.enable;

            if (divEnabled && Utils.isInArray(mode, divMode)) {
              this.singleDivModeExecute(div, callback);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      } else {
        var _divMode = divs.mode;
        var _divEnabled = divs.enable;

        if (_divEnabled && Utils.isInArray(mode, _divMode)) {
          this.singleDivModeExecute(divs, callback);
        }
      }
    }
  }, {
    key: "singleDivModeExecute",
    value: function singleDivModeExecute(div, callback) {
      var ids = div.ids;

      if (ids instanceof Array) {
        var _iterator2 = _createForOfIteratorHelper(ids),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var id = _step2.value;
            callback(id, div);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      } else {
        callback(ids, div);
      }
    }
  }, {
    key: "divMode",
    value: function divMode(divs, divId) {
      if (!divId) {
        return;
      }

      if (!divs) {
        return;
      }

      if (divs instanceof Array) {
        return divs.find(function (d) {
          return Utils.isInArray(divId, d.ids);
        });
      } else if (Utils.isInArray(divId, divs.ids)) {
        return divs;
      }
    }
  }, {
    key: "animate",
    get: function get() {
      return this.isSsr() ? function (callback) {
        return setTimeout(callback);
      } : function (callback) {
        return (window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || window.setTimeout)(callback);
      };
    }
  }, {
    key: "cancelAnimation",
    get: function get() {
      return this.isSsr() ? function (handle) {
        return clearTimeout(handle);
      } : function (handle) {
        return (window.cancelAnimationFrame || window.webkitCancelRequestAnimationFrame || window.mozCancelRequestAnimationFrame || window.oCancelRequestAnimationFrame || window.msCancelRequestAnimationFrame || window.clearTimeout)(handle);
      };
    }
  }]);

  return Utils;
}();

exports.Utils = Utils;